/**
 * Remove cached host access token from localStorage.
 * Safe to call in any environment; errors are ignored.
 */
export function purgeHostTokenCache(): void {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.removeItem('ptek_auth_hostAccessToken');
    }
  } catch {
    // ignore storage errors
  }
}
